import styled from 'styled-components';

export const BarWrapper = styled.div`
  display: flex;
  border-radius: 5px;

  div::after {
    /* needs !important to override tooltip styles */
    background-color: #404760 !important;
    box-shadow: 0 2px 12px 0 rgba(171, 185, 205, 0.4) !important;
    font-family: 'Nunito Sans', sans-serif !important;
    height: 28px !important;
  }

  div:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  div:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

export const Item = styled.div`
  flex: ${(props) => props.value};
  background-color: ${(props) => props.color};
  height: 8px;
`;

export const LabelGroup = styled.div`
  display: flex;
  justify-content: space-between;
  line-height: 1;
  margin-bottom: 11px;
`;

export const LabelWrapper = styled.div`
  height: 10px;
  display: flex;
  color: rgba(0, 0, 0, 0.85);
  font-size: 12px;
  align-items: center;
`;

export const LabelColorMarker = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 2px;
  margin-right: 4px;
  background-color: ${(props) => props.color};
`;
